import './style.scss';
import { OverseasRealEstateFatcaResponse } from './response';
import { OverseasRealEstateFatcaPageStep, useOverseasRealEstateFatca } from './hooks';
import { OverseasRealEstateFatcaRequirementsCheck } from './requirementsCheck';
import { ApplicationDenied } from './applicationDenied';

type OverseasRealEstateFatcaWrapperProps = {
    navigate: () => void;
}
export const OverseasRealEstateFatcaWrapper = ({navigate}: OverseasRealEstateFatcaWrapperProps) => {
    const {pageStep, nextPage} = useOverseasRealEstateFatca(navigate);

    return (        
        <div className='overseas-real-estate-fatca'>   
            <OverseasRealEstateFatca pageStep={pageStep} nextPage={nextPage} />
        </div>
    );
};

const OverseasRealEstateFatca = ({pageStep, nextPage} : ReturnType<typeof useOverseasRealEstateFatca>) => {
    switch(pageStep){
        case OverseasRealEstateFatcaPageStep.ANSWER1:
            return <OverseasRealEstateFatcaRequirementsCheck navigate={nextPage} />;
        case OverseasRealEstateFatcaPageStep.ANSWER2:
            return <OverseasRealEstateFatcaResponse navigate={nextPage}/>;
        case OverseasRealEstateFatcaPageStep.ERROR1:
            return <ApplicationDenied/>;        
    }
};